import React, { useState, useRef, useEffect } from 'react';
// Components
import emptyCpayImage from '../../../img/cpay-svg/empty.svg';
import emptyNFGImage from '../../../img/nfgpay-svg/empty-nfg.svg';
import emptyFinvaroImage from '../../../img/finvaro/empty-finvaro.svg';
import emptyClarniumImage from '../../../img/clarnium/empty-clarnium.svg';
import emptyInexImage from '../../../img/inex/empty-inex.svg';
import emptyInstaImage from '../../../img/instaXchange/empty-insta.svg';
import emptyCoineraImage from '../../../img/coinera/empty-coinera.svg';
import noCheckoutImgSVG from '../../../img/default-svg/no-checkout-image.svg';
import moreSVG from '../../../img/default-svg/more.svg';
import moreSVGInex from '../../../img/inex/more.svg';
import transactionsSVG from '../../../img/default-svg/checkoutTransactions.svg';
import transactionsSVGInex from '../../../img/inex/checkoutTransactions.svg';
import transactionsSVGInsta from '../../../img/instaXchange/checkoutTransactions.svg';
import transactionsSVGCoinera from '../../../img/coinera/checkoutTransactions.svg';
import editSVG from '../../../img/default-svg/edit.svg';
import editSVGInex from '../../../img/inex/edit.svg';
import editSVGInsta from '../../../img/instaXchange/edit.svg';
import editSVGCoinera from '../../../img/coinera/edit.svg';
import deleteSVG from '../../../img/default-svg/trash.svg';
import deleteSVGInex from '../../../img/inex/trash.svg';
import deleteSVGInsta from '../../../img/instaXchange/trash.svg';
import deleteSVGCoinera from '../../../img/coinera/trash.svg';
import copySVG from '../../../img/default-svg/copyCheckout.svg';
import copySVGInex from '../../../img/inex/copyCheckout.svg';
import copySVGInsta from '../../../img/instaXchange/copyCheckout.svg';
import copySVGCoinera from '../../../img/coinera/copyCheckout.svg';
import duplicateSVG from '../../../img/default-svg/duplicate.svg';
import duplicateSVGInex from '../../../img/inex/duplicate.svg';
import duplicateSVGInsta from '../../../img/instaXchange/duplicate.svg';
import duplicateSVGCoinera from '../../../img/coinera/duplicate.svg';
import Button from '../../Button';
import { Menu, Dropdown, Modal, Popover } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import DeletePlan from "../CheckoutsModals/DeletePlan";
// Utils
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Style
import './style.scss';
//icons
import donationIcon from '../../../img/checkout-types/donation.svg';
import donationIconInex from '../../../img/inex/donation.svg';
import donationIconInsta from '../../../img/instaXchange/donation.svg';
import donationIconCoinera from '../../../img/coinera/donation.svg';
import p2pIcon from '../../../img/checkout-types/p2p.svg';
import p2pIconInex from '../../../img/inex/p2p.svg';
import p2pIconInsta from '../../../img/instaXchange/p2p.svg';
import p2pIconCoinera from '../../../img/coinera/p2p.svg';
import sellIcon from '../../../img/checkout-types/sell.svg';
import sellIconInex from '../../../img/inex/sell.svg';
import sellIconInsta from '../../../img/instaXchange/sell.svg';
import sellIconCoinera from '../../../img/coinera/sell.svg';

import { identity } from '../../../utils/getIdentity';

const checkoutsNoDataSVG = {
  cpay: emptyCpayImage,
  nfg: emptyNFGImage,
  finvaro: emptyFinvaroImage,
  clarnium: emptyClarniumImage,
  inex: emptyInexImage,
  insta: emptyInstaImage,
  coinera: emptyCoineraImage
}

const deleteIcon = {
  cpay: deleteSVG,
  nfg: deleteSVG,
  finvaro: deleteSVG,
  clarnium: deleteSVG,
  inex: deleteSVGInex,
  insta: deleteSVGInsta,
  coinera: deleteSVGCoinera
}

const checkoutIcon = {
  cpay: transactionsSVG,
  nfg: transactionsSVG,
  finvaro: transactionsSVG,
  clarnium: transactionsSVG,
  inex: transactionsSVGInex,
  insta: transactionsSVGInsta,
  coinera: transactionsSVGCoinera
}

const copyIcon = {
  cpay: copySVG,
  nfg: copySVG,
  finvaro: copySVG,
  clarnium: copySVG,
  inex: copySVGInex,
  insta: copySVGInsta,
  coinera: copySVGCoinera
}

const duplicateIcon = {
  cpay: duplicateSVG,
  nfg: duplicateSVG,
  finvaro: duplicateSVG,
  clarnium: duplicateSVG,
  inex: duplicateSVGInex,
  insta: duplicateSVGInsta,
  coinera: duplicateSVGCoinera
}

const editIcon = {
  cpay: editSVG,
  nfg: editSVG,
  finvaro: editSVG,
  clarnium: editSVG,
  inex: editSVGInex,
  insta: editSVGInsta,
  coinera: editSVGCoinera
}

const { confirm } = Modal;

function showPromiseConfirm(t, name, type, action, walletVersion, merchantId, checkoutId, page) {
  confirm({
    title: `${t('checkouts.deleteTitle')} ${t(type.toLowerCase())}?`,
    icon: <ExclamationCircleOutlined />,
    content: name,
    onOk() {
      return action({ merchantId, checkoutId, walletVersion }, page);
    },
    onCancel() {},
    okText: t('okButton'),
    cancelText: t('cancelButton'),
  });
}

const donationIcons = {
  cpay: donationIcon,
  nfg: donationIcon,
  finvaro: donationIcon,
  clarnium: donationIcon,
  inex: donationIconInex,
  insta: donationIconInsta,
  coinera: donationIconCoinera
}

const p2pIcons = {
  cpay: p2pIcon,
  nfg: p2pIcon,
  finvaro: p2pIcon,
  clarnium: p2pIcon,
  inex: p2pIconInex,
  insta: p2pIconInsta,
  coinera: p2pIconCoinera
}

const sellIcons = {
  cpay: sellIcon,
  nfg: sellIcon,
  finvaro: sellIcon,
  clarnium: sellIcon,
  inex: sellIconInex,
  insta: sellIconInsta,
  coinera: sellIconCoinera
}

const iconObj = {
  donation: donationIcons[identity],
  sale: sellIcons[identity],
  saletoken: p2pIcons[identity],
  cart: sellIcons[identity],
};

const CheckoutsList = ({
  data,
  page,
  type,
  fetching,
  setIsVisible,
  deleteCheckout,
  walletVersion,
  merchantId,
  openDetailedHandler,
  openEditHandler,
  openDuplicateHandler,
  deletePlan,
  typeNetwork,
  getPlansList,
  supportedCurrencies
}) => {
  const [showAddressCopiedPopover, setShowAddressCopiedPopover] = useState(false);
  const [isOpenDeletePlan, setIsOpenDeletePlan] = useState(false);
  const [currency, setCurrency] = useState('');
  const [currentId, setCurrentId] = useState('');
  const { t } = useTranslation();
  const addressCopyPopoverTimer = useRef(null);

  const location = window.location.href
  const checkoutLinkCPay = location.includes('demo') || location.includes('localhost')
      ? 'https://checkouts-geme-wallet-demo.gemewallet.com/'
      : location.includes('stage')
      ? 'https://checkouts-geme-wallet-stage.gemewallet.com/'
      : 'https://checkouts.gemewallet.com/';
  const checkoutLinkNFG = 'https://checkouts.crypto-now.io/';
  const checkoutLinkFinvaro = 'https://checkouts.finvaro.com/';
  const checkoutLinkClarnium = 'https://checkouts.clarnium.io/';
  const checkoutLinkInex = 'https://checkouts.inexlatampay.com/';
  const checkoutLinkInsta = 'https://checkouts.instaxgateway.com/';
  const checkoutLinkFinera = 'https://checkouts-coin.finera.com/'

  const checkoutLink = {
   cpay: checkoutLinkCPay,
   nfg: checkoutLinkNFG,
   finvaro: checkoutLinkFinvaro,
   clarnium: checkoutLinkClarnium,
   inex: checkoutLinkInex,
   insta: checkoutLinkInsta,
   coinera: checkoutLinkFinera
  }

  // const checkoutSaleLink = {
  //   cpay: 'sell-token-checkout',
  //   nfg: 'sale-token-checkout'
  //  }

  const periodType = {
    0: t('admin.hourly'),
    1: t('admin.daily'),
    2: t('admin.weekly'),
    3: t('admin.monthly'),
    4: t('admin.yearly'),
  };

  const openDeleteModal = (id) => {
    setIsOpenDeletePlan(true);
    setCurrentId(id);
  }

  const addressCopyHandler = (identifier, type) => {
    navigator.clipboard.writeText(`${checkoutLink[identity]}${type === 'saletoken' ? 'sell-token-checkout' : 'checkout'}/${identifier}`);
    setShowAddressCopiedPopover(true);
    addressCopyPopoverTimer.current = setTimeout(() => setShowAddressCopiedPopover(false), 1000);
  };

  const removePlan = async () => {
    await deletePlan(currentId, merchantId, typeNetwork);

    setIsOpenDeletePlan(false);
    await getPlansList({
      merchantId,
      params: {
        typeNetwork,
        page,
        limit: 5,
        order: 'DESC'
      },
    });
  }

  return (
    <div className="checkouts-list">
      {fetching ? (
        <div>{t('swap.loading')}...</div>
      ) : data && data.length !== 0 ? (
        data.map(el => (
          <div key={el._id} className={`checkouts-list__checkout checkouts-list__checkout-${identity}`}>
            <div className="checkouts-list__checkout-image" onClick={() => {
              if (type !== 'plan') {
                openDetailedHandler(el);
              }
            }}>
              <img src={el.image ? `${process.env.REACT_APP_API_URL}${el.image}` : noCheckoutImgSVG} alt="" />
            </div>
            <div className={type === 'plan' ? 'checkouts-list__checkout-info--plan' : 'checkouts-list__checkout-info'} onClick={() => {
              if (type !== 'plan') {
                openDetailedHandler(el);
              }
            }}>
              <div className={`checkouts-list__checkout-info-name checkouts-list__checkout-info-name-${identity}`}>
                {el.organizationName || el.productName || el.cartName || el.name}
              </div>
              <div className={`checkouts-list__checkout-info-description checkouts-list__checkout-info-description-${identity}`} onClick={() => {
                if (type !== 'plan') {
                  openDetailedHandler(el);
                }
              }}>
                {el.description}
              </div>
            </div>
            <div className={`checkouts-list__checkout-type checkouts-list__checkout-type-${identity}`} onClick={() => {
              if (type !== 'plan') {
                openDetailedHandler(el);
              }
            }}>
              {type === 'plan' && (
                <div className={`checkouts-list__checkout-price checkouts-list__checkout-price-${identity}`} onClick={() => {
                  if (type !== 'plan') {
                    openDetailedHandler(el);
                  }
                }}>
                  <span>{el?.activeSubscriptions}/{el?.subscriptionsTotal}</span>
                </div>
              )}

              {type === 'plan' && (
                <div className={`checkouts-list__checkout-price checkouts-list__checkout-price-${identity}`} onClick={() => {
                  if (type !== 'plan') {
                    openDetailedHandler(el);
                  }
                }}>
                  <span className=
                          {`checkouts-list__checkout-price--block ${el?.published === false ? 'checkouts-list__checkout-price--block--draft' : el?.published === true && el?.status === false ? 'checkouts-list__checkout-price--block--deactive' : 'checkouts-list__checkout-price--block--active'}`}
                  ></span>
                  <span className={el?.published === false ? 'checkouts-list__checkout-price--draft' : el?.published === true && el?.status === false ? 'checkouts-list__checkout-price--deactive' : 'checkouts-list__checkout-price--active'}>
                    {el?.published === false ? 'Draft' : el?.published === true && el?.status === false ? 'Deactive' : 'Active'}
                  </span>
                </div>
              )}

              {type === 'plan' && (
                <div className={`checkouts-list__checkout-price checkouts-list__checkout-price-${identity}`} onClick={() => {
                  if (type !== 'plan') {
                    openDetailedHandler(el);
                  }
                }}>
                  <span>{periodType[el?.periodType]}</span>
                </div>
              )}
              {type === 'plan' && (
                <div className={`checkouts-list__checkout-price checkouts-list__checkout-price-${identity}`} onClick={() => {
                  if (type !== 'plan') {
                    openDetailedHandler(el);
                  }
                }}>
                  <span>{el?.price}{' '}{el?.nodeType?.toUpperCase()}</span>
                </div>
              )}
              {type === 'plan' && (
                <div className={`checkouts-list__checkout-price checkouts-list__checkout-price-${identity}`} onClick={() => {
                  if (type !== 'plan') {
                    openDetailedHandler(el);
                  }
                }}>
                  <span>{el?.totalAmount}$</span>
                </div>
              )}
              {type !== 'plan' && (
                <div>
                  <img
                    src={iconObj[el.type.toLowerCase()]}
                    alt={el.type}
                    className={`checkouts-list__checkout-type_icon checkouts-list__checkout-type-${identity}_icon`}
                  />
                  {t(el.type.toLowerCase())}
                </div>
              )}


              {el.price && el.fiatCurrency && type !== 'plan' && (
                <div className={`checkouts-list__checkout-price checkouts-list__checkout-price-${identity}`} onClick={() => {
                  if (type !== 'plan') {
                    openDetailedHandler(el);
                  }
                }}>
                  <span className={el.price.length >= 5 ? 'long-price' : ''}>{el.price}</span>{' '}
                  <span>{el.fiatCurrency}</span>
                </div>
              )}
            </div>
            <Dropdown
              placement="bottomLeft"
              overlay={
                <Menu className={`menu menu-${identity}`}>
                  {type !== 'plan' && (
                    <Menu.Item key="0">
                      <Link to={`/?checkoutId=${el.identifier}`} className="checkouts-list__checkout-drop-item">
                        <div className="checkouts-list__checkout-drop-item">
                          <img src={checkoutIcon[identity]} alt="" />
                          {t('transactions')}
                        </div>
                      </Link>
                    </Menu.Item>
                  )}
                  {type === 'plan' && (
                    <Menu.Item key="0">
                      <Link to={`/subscriptions/?planId=${el._id}`} className="checkouts-list__checkout-drop-item">
                        <div className="checkouts-list__checkout-drop-item">
                          <img src={checkoutIcon[identity]} alt="" />
                          Subscriptions
                        </div>
                      </Link>
                    </Menu.Item>
                  )}
                  {type === 'plan' && (
                    <Menu.Item key="0">
                      <Link to={`/activities/?planId=${el._id}`} className="checkouts-list__checkout-drop-item">
                        <div className="checkouts-list__checkout-drop-item">
                          <img src={checkoutIcon[identity]} alt="" />
                          Activities
                        </div>
                      </Link>
                    </Menu.Item>
                  )}
                  {type !== 'plan' && (
                    <Menu.Item key="2">
                      <Popover
                        title=""
                        content={t('copied')}
                        trigger="click"
                        visible={showAddressCopiedPopover}
                        className="detailed-checkout__popover"
                      >
                        <div
                          className="checkouts-list__checkout-drop-item"
                          onClick={() => addressCopyHandler(el.identifier, el.type.toLowerCase())}
                        >
                          <img src={copyIcon[identity]} alt="" />
                          {t('copyLink')}
                        </div>
                      </Popover>
                    </Menu.Item>
                  )}
                  {type !== 'plan' && (
                    <Menu.Item key="3">
                      <div className="checkouts-list__checkout-drop-item" onClick={() => openDuplicateHandler(el)}>
                        <img src={duplicateIcon[identity]} alt="" />
                        {t('duplicate')}
                      </div>
                    </Menu.Item>
                  )}
                  <Menu.Item key="4">
                    <div className="checkouts-list__checkout-drop-item" onClick={() => openEditHandler(el)}>
                      <img src={editIcon[identity]} alt="" />
                      {t('edit')}
                    </div>
                  </Menu.Item>
                  {type !== 'plan' && (
                    <Menu.Item key="5">
                      <div
                        className="checkouts-list__checkout-drop-item"
                        onClick={() => {
                          const newPage = page < 2 ? 1 : data && data.length - 1 > 0 ? page : page - 1;
                          showPromiseConfirm(
                            t,
                            el.organizationName,
                            el.type,
                            deleteCheckout,
                            walletVersion,
                            merchantId,
                            el._id,
                            newPage
                          );
                        }}
                      >
                        <img src={deleteIcon[identity]} alt="" /> {t('delete')}
                      </div>
                    </Menu.Item>
                  )}
                  {type === 'plan' && (
                    <Menu.Item key="5">
                      <div
                        className="checkouts-list__checkout-drop-item"
                        onClick={() => openDeleteModal(el?._id)}
                      >
                        <img src={deleteIcon[identity]} alt="" /> {t('delete')}
                      </div>
                    </Menu.Item>
                  )}
                </Menu>
              }
              trigger={['click']}
            >
              <div className="checkouts-list__checkout-actions">
                <img src={identity === 'inex' ? moreSVGInex : moreSVG} alt="" />
              </div>
            </Dropdown>
          </div>
        ))
      ) : (
        <div className="checkouts-list__empty">
          <div className="checkouts-list__empty-text">{type === 'plan' ? t('checkouts.noPlans') : t('checkouts.noCheckouts')}</div>
          <img src={checkoutsNoDataSVG[identity]} alt="" />
          <Button type="primary" className="checkouts-list__button" onClick={() => setIsVisible(true)}>
            {type === 'plan' ? t('checkouts.createPlan') : t('checkouts.createCheckout')}
          </Button>
        </div>
      )}

      <DeletePlan removePlan={removePlan} visible={isOpenDeletePlan} close={() => setIsOpenDeletePlan(false)} />
    </div>
  );
};

export default CheckoutsList;
